/*
* Created on Jan 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useState, useReducer, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import TableComponent from "../common/TableComponent/TableComponent";
import ic_content_activity_svg from "../../static/img/content/ic-content-activity-log.svg";
import ActivityLogTableRowComponent from "./ActivityLogTableRowComponent";
import {useAuthSession} from "../../context/AuthSessionContext";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useRegion} from "../../context/RegionContext";
import {useOrganization} from "../../context/OrganizationContext";


const table_ui = {
    toolbar: {
        count: false,
        create_button: false,
        delete_button: false,
        export_button: true
    },
    table_field_checkbox: false
}


const ActivityLogIndexComponent = () => {
    const {t, i18n} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const {userProfile} = useOrganization();
    const {is_owner} = userProfile();
    const {url} = useRegion();
    const {useCheckSession} = useAuthSession();
    const {oid} = useParams();
    const [refresh, setRefresh] = useState(0);
    const [page, setPage] = useState({limit:10, offset:0});
    const { data } = useQuery({
        queryKey: [`organization_activity/${oid}`, page, i18n.language, refresh],
        queryFn: async ({signal}) => {
            const activity_list = await OrganizationAPI.get(`organization_activity`, {organization_id: oid, ...page, lang: i18n.language}, false, signal);
            return activity_list.result;
        }
    });

    const table_head_fields = [
        {
            field_name: t('@Category@'),
            isSortable: false,
            width_style: '!w-13',
            // filters: [
            //     {name: 'Account', value: 1, checked: true},
            //     {name: 'Organization', value: 2, checked: true},
            //     {name: 'Group', value: 3, checked: true},
            //     {name: 'Site', value: 4, checked: true}
            // ]
        },
        {field_name: t('@Event@'), isSortable: false, width_style: '!w-12'},
        {field_name: t('@Status@'), isSortable: false, width_style: '!w-27'},
        {field_name: t('@Initiated by@'), isSortable: false, width_style: '!w-20'},
        {field_name: t('@Location@'), isSortable: false, width_style: '!w-12'},
        {field_name: t('@Creation date@'), isSortable: false, width_style: '!w-16 justify-content-end', default_sort: true, field_id: 'created_at'},
    ];

    const dispatch_handler = (activity_state, action) => {
        switch (action.type) {
            case 'init':
                activity_state.data = action.payload.activities;
                activity_state.total = action.payload.total;
                activity_state.select_box = false;
                activity_state.search = (obj, query) => {
                    if (activity_state.field_filter) {
                        return activity_state.field_filter.includes(obj.category) && obj.content.match(new RegExp(query, 'i'))
                    }
                    return obj.content.match(new RegExp(query, 'i'))
                };
                return {...activity_state};
            case 'pagination':
                setPage({limit:action.payload.limit, offset:action.payload.offset});
                if (action.payload.refresh) {
                    setRefresh(prev=>prev+1);
                }
                return {...activity_state}
            case 'search_activity_log':
                return {
                    ...activity_state,
                    query: action.payload
                };
            case 'update_field_filter':
                return {
                    ...activity_state,
                    field_filter: action.payload.query,
                }
            case 'export_activity_log':
                window.location = `${url.get_org_api_url()}/v1.2/organization_activity/export?organization_id=${oid}&access_token=${OrganizationAPI.getToken()}`
                return activity_state;
            default:
                return activity_state;
        }
    }

    const [state, dispatch] = useReducer(dispatch_handler, {});

    useEffect(()=>{
        if (data) {
            dispatch({type: 'init', payload: data})
        }
    }, [data, i18n.language]);
    useCheckSession();

    return (
        <div className="content content-page">
            {/*{data &&*/}
                <TableComponent
                    name="Activity log"
                    table_icon={ic_content_activity_svg}
                    table_head_fields={table_head_fields}
                    table_data={state}
                    total_record={state.total}
                    row_component={ActivityLogTableRowComponent}
                    search={true}
                    disPatcher={dispatch}
                    table_ui={table_ui}
                    isOwner={is_owner}
                    data_table_name={'activity-log-table'}
                >
                </TableComponent>
            {/*}*/}
        </div>
    );
};

export default ActivityLogIndexComponent;